const all = ['ordoclic']
const detail = (id?: number) => [...all, id]
const consult = () => [...all, 'consult']

export const ordoclicKeys = {
  all,
  detail,
  consult,
}
